import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'others',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './others.component.html',
  styleUrl: './others.component.css'
})
export class OthersComponent implements OnInit, OnChanges {

  @Input() parentInterviewData: any;
  @Output() onSaveSection11 = new EventEmitter<any>();

  yesNo = EYesNo;
  othersForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'more_information',
      questionText: 'Is there other information regarding your child that you have not yet shared that you believe would be important for the behavioral threat assessment team to consider? *',
      formControlName: 'more_information',
      infoFormControlName: 'more_information_information'
    },
    {
      id: 'confidentiality_waiver',
      questionText: 'If you identified medical, mental health, or other service providers who work with your child, are you willing to sign confidentiality waivers to allow us to discuss your child and this situation directly with that provider? *',
      formControlName: 'confidentiality_waiver',
      infoFormControlName: 'confidentiality_waiver_information'
    },
    {
      id: 'other_person',
      questionText: 'Is there anyone else you believe we should talk to about your child on this situation? *',
      formControlName: 'other_person',
      infoFormControlName: 'other_person_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });

    this.othersForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.othersForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.othersForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveOthers(): void {
    if (this.othersForm.valid) {
      this.onSaveSection11.emit(this.othersForm.value);
    }
  }

}
